import React, { useState, useEffect } from 'react';
import Layout from '../shared/Layout';

// Importación de los componentes del módulo
import InscripcionesEstudiante from './InscripcionesEstudiante';
import HistorialAcademicoEstudiante from './HistorialAcademicoEstudiante';
import HistorialAcademicoAdmision from '../preadmision_curso/HistorialAcademicoAdmision';
import HistorialAcademicoPruebaAdmision from '../preadmision_prueba/HistorialAcademicoPruebaAdmision';
import AsignaturasEstudiante from './AsignaturasEstudiante';
import LicenciasEstudiante from './LicenciasEstudiante';
import TalleresEstudiante from './TalleresEstudiante';
import ReportesEstudiante from './ReportesEstudiante';
import EncuestasEstudiante from './EncuestasEstudiante';
import TareasEstudiante from './TareasEstudiante';
import SuspendedDashboard from './SuspendedDashboard';
import SpecialAdmissionDashboard from './SpecialAdmissionDashboard';
import AsignaturasPreadmision from '../preadmision_curso/AsignaturasPreadmision';
import AsignaturasPruebaAdmision from '../preadmision_prueba/AsignaturasPruebaAdmision';

// Orden deseado por el usuario
const orderMap = {
  'reportes': 1, 'estudiante_reportes': 1, // Comunicados
  'inscripciones': 2, 'estudiante_inscripciones': 2, // Matriculación
  'asignaturas': 3, 'estudiante_asignaturas': 3, // Inscripción Asignaturas
  'historial': 4, 'estudiante_historial': 4, // Historial
  'tareas': 5, 'estudiante_examenes': 5, // Evaluaciones
  'licencias': 6, 'estudiante_licencias': 6, // Licencias
  'talleres': 7, 'cursos_extension': 7, 'estudiante_cursos': 7, // Cursos Extensión
  'encuestas': 8, 'estudiante_encuestas': 8 // Encuestas
};

const DashboardEstudiante = ({ onLogout }) => {
  const [activeMenu, setActiveMenu] = useState('');
  const [menuItems, setMenuItems] = useState([]);
  const [userInfo, setUserInfo] = useState({ userName: '', userRole: '' });
  const [modalidad, setModalidad] = useState(localStorage.getItem('modalidad_postulacion') || '');
  const [etapaAcademica, setEtapaAcademica] = useState(localStorage.getItem('etapa_academica') || '');
  const [isSuspended, setIsSuspended] = useState(false);
  const [suspensionData, setSuspensionData] = useState(null);
  const [graduadeInfo, setGraduadeInfo] = useState({ promedio_general: 0, materias_con_nota: 0, max_nota: 0 });

  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api/v1';

  // 1. Cargar información inicial y del backend
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const token = localStorage.getItem('token');

    if (user.is_suspended) {
      setIsSuspended(true);
      setSuspensionData({
        fecha_suspension: user.fecha_suspension,
        resolucion_suspension: user.resolucion_suspension
      });
    }

    const nombreCompleto = user.nombre_completo || user.username || 'Usuario';
    setUserInfo(prev => ({ ...prev, userName: nombreCompleto }));

    const fetchEstudianteInfo = async () => {
      try {
        const headers = token ? { 'Authorization': `Bearer ${token}` } : {};
        const res = await fetch(`${API_URL}/estudiante/info-matriculacion?id_usuario=${user.id_usuario}`, { headers });
        if (res.ok) {
          const data = await res.json();
          const est = data.estudiante || {};

          const etapaReal = est.etapa_academica || '';
          const estaMatriculado = etapaReal === 'matriculado' || etapaReal === 'licenciatura';

          const carrera = est.carrera || '';
          const mencion = est.mencion || '';
          const roleText = estaMatriculado
            ? [carrera, mencion].filter(Boolean).join(' - ') || 'Estudiante Matriculado'
            : 'Estudiante en Admisión';

          const apellidos = [est.apellido_paterno, est.apellido_materno].filter(Boolean).join(' ');
          const nombreCompleto2 = [est.nombres, apellidos].filter(Boolean).join(' ') || nombreCompleto;

          setUserInfo({
            userName: nombreCompleto2,
            userRole: roleText
          });

          setModalidad(est.modalidad_postulacion || '');
          setEtapaAcademica(etapaReal || 'admision');

          if (est.etapa_academica) {
            localStorage.setItem('etapa_academica', etapaReal || 'admision');
          }
          if (est.modalidad_postulacion) localStorage.setItem('modalidad_postulacion', est.modalidad_postulacion);

          setGraduadeInfo({
            promedio_general: est.promedio_general || 0,
            materias_con_nota: est.materias_con_nota || 0,
            max_nota: est.max_nota || 0
          });
        }
      } catch (e) {
        console.error('Error cargando info estudiante:', e);
      }
    };

    fetchEstudianteInfo();
  }, []);

  // 2. Filtrar y ordenar menús cuando cambian los datos académicos
  // useEffect(() => {
  //   const menus = JSON.parse(localStorage.getItem('menus') || '[]');
  //   const isEnrolled = etapaAcademica === 'matriculado' || etapaAcademica === 'licenciatura';

  //   // Filtrar menús del estudiante (todos los que pertenezcan a la rama "Estudiante")
  //   const studentRoot = menus.find(parent => parent.clave === 'estudiante_root' || parent.id_menu === '1');
  //   let estudianteMenus = menus.filter(m => {
  //     return studentRoot ? m.id_menu !== studentRoot.id_menu : true;
  //   });

  //   // Definición de menús completos para estudiantes de Licenciatura / Aprobados
  //   const fullStudentMenus = [
  //     { id_menu: 'reportes', clave: 'estudiante_reportes', etiqueta: 'Comunicados' },
  //     { id_menu: 'inscripciones', clave: 'estudiante_inscripciones', etiqueta: 'Matriculación' },
  //     { id_menu: 'asignaturas', clave: 'estudiante_asignaturas', etiqueta: 'Inscripción Asignaturas' },
  //     { id_menu: 'historial', clave: 'estudiante_historial', etiqueta: 'Historial Académico' },
  //     { id_menu: 'tareas', clave: 'estudiante_examenes', etiqueta: 'Evaluaciones' },
  //     { id_menu: 'licencias', clave: 'estudiante_licencias', etiqueta: 'Solicitud Permiso' },
  //     { id_menu: 'talleres', clave: 'estudiante_cursos', etiqueta: 'Cursos de Extensión' },
  //     { id_menu: 'encuestas', clave: 'estudiante_encuestas', etiqueta: 'Encuestas' }
  //   ];

  //   const reqMaterias = mod => mod.includes('Curso') || mod.includes('CPA') ? 1 : 1;
  //   const isApproved = (graduadeInfo.max_nota >= 61 || graduadeInfo.promedio_general >= 61) && (graduadeInfo.materias_con_nota >= reqMaterias(modalidad));

  //   let menusToUse = [];

  //   if (isEnrolled) {
  //     // Matriculado: set completo de menús
  //     menusToUse = fullStudentMenus;
  //   } else if (etapaAcademica === 'admision_aprobado') {
  //     const isAE = modalidad?.toUpperCase().includes('ESPECIAL') || modalidad?.toUpperCase().includes('AE');
  //     if (isAE) {
  //       menusToUse = fullStudentMenus;
  //     } else {
  //       const allowedAprobado = [
  //         'reportes', 'estudiante_reportes',
  //         'inscripciones', 'estudiante_inscripciones',
  //         'historial', 'estudiante_historial'
  //       ];
  //       menusToUse = fullStudentMenus.filter(m =>
  //         allowedAprobado.includes(m.clave) || allowedAprobado.includes(m.id_menu)
  //       );
  //     }
  //   } else {
  //     // Usar la lista completa definida en el frontend como base para el filtrado en etapa de admisión,
  //     // esto asegura que se muestren los menús necesarios incluso si el rol en BD (ej: postulante) es restrictivo.
  //     const baseMenus = fullStudentMenus;
  //     const allowedClaves = [
  //       'reportes', 'estudiante_reportes',
  //       'asignaturas', 'estudiante_asignaturas',
  //       'historial', 'estudiante_historial'
  //     ];
  //     // Si ya aprobó la admisión (por notas), habilitar el menú de matriculación para que pueda continuar por su cuenta
  //     if (isApproved) {
  //       allowedClaves.push('inscripciones');
  //       allowedClaves.push('estudiante_inscripciones');
  //     }
  //     menusToUse = baseMenus.filter(m =>
  //       allowedClaves.includes(m.clave) || allowedClaves.includes(m.id_menu)
  //     );
  //   }

  //   // Ordenar y guardar
  //   const sorted = [...menusToUse].sort((a, b) => {
  //     const keyA = a.clave || a.id_menu;
  //     const keyB = b.clave || b.id_menu;
  //     const orderA = orderMap[keyA] || 99;
  //     const orderB = orderMap[keyB] || 99;
  //     return orderA - orderB;
  //   });

  //   setMenuItems(sorted);

  //   if (sorted.length > 0) {
  //     const currentValid = sorted.find(m => (m.clave || m.id_menu) === activeMenu);
  //     if (!currentValid) {
  //       setActiveMenu(sorted[0].clave || sorted[0].id_menu);
  //     }
  //   }
  // }, [etapaAcademica, graduadeInfo, modalidad]);

  // 2. Filtrar y ordenar menús cuando cambian los datos académicos
  useEffect(() => {
    const menus = JSON.parse(localStorage.getItem('menus') || '[]');
    const isEnrolled = etapaAcademica === 'matriculado' || etapaAcademica === 'licenciatura';

    // Filtrar menús del estudiante (todos los que pertenezcan a la rama "Estudiante")
    const studentRoot = menus.find(parent => parent.clave === 'estudiante_root' || parent.id_menu === '1');
    let estudianteMenus = menus.filter(m => {
      return studentRoot ? m.id_menu !== studentRoot.id_menu : true;
    });

    // Definición de menús completos para estudiantes de Licenciatura / Aprobados
    const fullStudentMenus = [
      { id_menu: 'reportes', clave: 'estudiante_reportes', etiqueta: 'Comunicados' },
      { id_menu: 'inscripciones', clave: 'estudiante_inscripciones', etiqueta: 'Matriculación' },
      { id_menu: 'asignaturas', clave: 'estudiante_asignaturas', etiqueta: 'Inscripción Asignaturas' },
      { id_menu: 'historial', clave: 'estudiante_historial', etiqueta: 'Historial Académico' },
      { id_menu: 'tareas', clave: 'estudiante_examenes', etiqueta: 'Evaluaciones' },
      { id_menu: 'licencias', clave: 'estudiante_licencias', etiqueta: 'Solicitud Permiso' },
      { id_menu: 'talleres', clave: 'estudiante_cursos', etiqueta: 'Cursos de Extensión' },
      { id_menu: 'encuestas', clave: 'estudiante_encuestas', etiqueta: 'Encuestas' }
    ];

    const reqMaterias = mod => mod.includes('Curso') || mod.includes('CPA') ? 1 : 1;
    const isApproved = (graduadeInfo.max_nota >= 61 || graduadeInfo.promedio_general >= 61) && (graduadeInfo.materias_con_nota >= reqMaterias(modalidad));

    let menusToUse = [];

    if (isEnrolled) {
      // Matriculado: set completo de menús
      menusToUse = fullStudentMenus;
    } else if (etapaAcademica === 'admision_aprobado') {
      const isAE = modalidad?.toUpperCase().includes('ESPECIAL') || modalidad?.toUpperCase().includes('AE');
      if (isAE) {
        menusToUse = fullStudentMenus;
      } else {
        const allowedAprobado = [
          'reportes', 'estudiante_reportes',
          'inscripciones', 'estudiante_inscripciones',
          'historial', 'estudiante_historial'
        ];
        menusToUse = fullStudentMenus.filter(m =>
          allowedAprobado.includes(m.clave) || allowedAprobado.includes(m.id_menu)
        );
      }
    } else {
      const baseMenus = fullStudentMenus;
      const allowedClaves = [
        'reportes', 'estudiante_reportes',
        'asignaturas', 'estudiante_asignaturas',
        'historial', 'estudiante_historial'
      ];
      if (isApproved) {
        allowedClaves.push('inscripciones');
        allowedClaves.push('estudiante_inscripciones');
      }
      menusToUse = baseMenus.filter(m =>
        allowedClaves.includes(m.clave) || allowedClaves.includes(m.id_menu)
      );
    }

    // Ordenar y guardar
    const sorted = [...menusToUse].sort((a, b) => {
      const keyA = a.clave || a.id_menu;
      const keyB = b.clave || b.id_menu;
      const orderA = orderMap[keyA] || 99;
      const orderB = orderMap[keyB] || 99;
      return orderA - orderB;
    });

    setMenuItems(sorted);

    if (sorted.length > 0) {
      const currentValid = sorted.find(m => (m.clave || m.id_menu) === activeMenu);
      if (!currentValid) {
        setActiveMenu(sorted[0].clave || sorted[0].id_menu);
      }
    }
  }, [etapaAcademica, graduadeInfo, modalidad]);

  // 3. Polling: detectar cuando el admin procesa la matrícula sin recargar página
  useEffect(() => {
    const isEnrolled = etapaAcademica === 'matriculado' || etapaAcademica === 'licenciatura';
    if (isEnrolled) return; // ya matriculado, no necesita polling

    const token = localStorage.getItem('token');
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const headers = token ? { 'Authorization': `Bearer ${token}` } : {};

    const verificar = async () => {
      try {
        const res = await fetch(`${API_URL}/estudiante/info-matriculacion?id_usuario=${user.id_usuario}`, { headers });
        if (!res.ok) return;
        const data = await res.json();
        const est = data.estudiante || {};
        const etapaReal = est.etapa_academica || '';

        if (etapaReal === 'matriculado' || etapaReal === 'licenciatura') {
          // Actualizar etapa → dispara el useEffect de menús automáticamente
          setEtapaAcademica(etapaReal);
          localStorage.setItem('etapa_academica', etapaReal);

          // Actualizar rol que se muestra en el header
          const carrera = est.carrera || '';
          const mencion = est.mencion || '';
          setUserInfo(prev => ({
            ...prev,
            userRole: [carrera, mencion].filter(Boolean).join(' - ') || 'Estudiante Matriculado'
          }));
        }
      } catch (e) { /* silencioso */ }
    };

    const intervalo = setInterval(verificar, 10000); // cada 10 segundos
    return () => clearInterval(intervalo); // limpia al desmontar o cuando etapa cambia a matriculado
  }, [etapaAcademica]); // re-evalúa cuando etapa cambia; si ya es matriculado, sale sin crear intervalo

  // Renderizado dinámico del contenido
  const renderContent = () => {
    // Mapear tanto clave de BD como ID legacy
    const menuMap = {
      'estudiante_inscripciones': 'inscripciones',
      'estudiante_historial': 'historial',
      'estudiante_asignaturas': 'asignaturas',
      'estudiante_examenes': 'tareas',
      'estudiante_licencias': 'Solicitud Permiso',
      'estudiante_cursos': 'talleres',
      'estudiante_reportes': 'reportes',
      'estudiante_encuestas': 'encuestas'
    };

    const menuKey = menuMap[activeMenu] || activeMenu;

    const isEnrolled = etapaAcademica === 'matriculado' || etapaAcademica === 'licenciatura';
    const reqMaterias = mod => (mod && (mod.includes('Curso') || mod.includes('CPA'))) ? 1 : 1;
    // Ahora confiamos también en el estado explícito de la base de datos para la transición
    const isApproved = etapaAcademica === 'admision_aprobado' || 
                      ((graduadeInfo.max_nota >= 61 || graduadeInfo.promedio_general >= 61) && 
                       (graduadeInfo.materias_con_nota >= reqMaterias(modalidad)));

    switch (menuKey) {
      case 'inscripciones': return <InscripcionesEstudiante />;
      case 'historial':
        if (isEnrolled || isApproved) return <HistorialAcademicoEstudiante />;
        if (etapaAcademica === 'preadmision_curso' || (modalidad && (modalidad.includes('Curso') || modalidad.includes('CPA')))) return <HistorialAcademicoAdmision />;
        if (etapaAcademica === 'preadmision_prueba' || (modalidad && (modalidad.includes('Prueba') || modalidad.includes('PAA')))) return <HistorialAcademicoPruebaAdmision />;
        return <HistorialAcademicoEstudiante />;
      case 'asignaturas':
        if (isEnrolled) return <AsignaturasEstudiante />;
        if (isApproved && !isEnrolled) {
          // Aprobado pero no matriculado: mostrar mensaje de espera
          return (
            <div className="bg-white shadow-xl rounded-2xl p-8 text-center border border-yellow-100 max-w-2xl mx-auto mt-10">
              <div className="w-20 h-20 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-10 h-10 text-yellow-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h2 className="text-xl font-bold text-gray-800 mb-2">Inscripción de Asignaturas No Disponible</h2>
              <p className="text-gray-600 mb-2">Has aprobado el proceso de admisión. ¡Felicidades!</p>
              <p className="text-gray-500 text-sm mb-6">Para inscribir materias de Licenciatura, primero debes completar tu <strong>matriculación</strong>. Puedes hacerlo tú mismo ahora mismo.</p>
              
              <button
                onClick={() => setActiveMenu('inscripciones')}
                className="px-6 py-2 bg-blue-900 text-white rounded-lg hover:bg-blue-800 transition-colors font-semibold"
              >
                Ir a Matriculación
              </button>
              
              <p className="text-xs text-blue-600 mt-4 italic">Una vez matriculado, se te asignará una carrera y podrás seleccionar tu horario.</p>
            </div>
          );
        }
        if (etapaAcademica === 'preadmision_curso' || (modalidad && (modalidad.includes('Curso') || modalidad.includes('CPA')))) return <AsignaturasPreadmision />;
        if (etapaAcademica === 'preadmision_prueba' || (modalidad && (modalidad.includes('Prueba') || modalidad.includes('PAA')))) return <AsignaturasPruebaAdmision />;
        return <AsignaturasEstudiante />;
      case 'Solicitud Permiso': return <LicenciasEstudiante />;
      case 'talleres': return <TalleresEstudiante />;
      case 'reportes': return <ReportesEstudiante />;
      case 'encuestas': return <EncuestasEstudiante />;
      case 'tareas': return <TareasEstudiante />;
      default: return <InscripcionesEstudiante />;
    }
  };

  // Formatear menuItems para el Layout compartido preservando jerarquía
  const formattedMenuItems = menuItems.map(item => ({
    id: item.clave || item.id_menu,
    id_menu: item.id_menu,
    id_padre: item.id_padre,
    label: item.etiqueta || item.label
  }));

  if (isSuspended) {
    return <SuspendedDashboard user={suspensionData} onLogout={onLogout} />;
  }

  // Verificar si es admisión especial pendiente de aprobación
  // Si la etapa es 'admision_especial' o 'especial' y NO es 'matriculado' o 'licenciatura'
  const isSpecialAdmissionPending = (etapaAcademica === 'admision_especial' || etapaAcademica === 'especial');

  if (isSpecialAdmissionPending) {
    return <SpecialAdmissionDashboard user={userInfo} onLogout={onLogout} />;
  }

  return (
    <Layout
      userName={userInfo.userName}
      userRole={userInfo.userRole}
      menuItems={formattedMenuItems}
      onLogout={onLogout}
      activeMenu={activeMenu}
      setActiveMenu={setActiveMenu}
    >
      {renderContent()}
    </Layout>
  );
};

export default DashboardEstudiante;